export const layoutTypes = {
  DELETE_MY_ITEM: 'DELETE_MY_ITEM',
};
